import angular from 'angular';

import component from './what.component';

const ExperienceWhat = angular
    .module('control-room.experience-promoter.components.experience-manage.components.what', [])
    .component('crExperienceWhat', component);

export default ExperienceWhat;
